import { IVendorDTO } from '../../../../services/quote/dto'
import AddOnProgramSection from './AddOnProgramSection'

interface AddOnProgramsSectionsContainerProps {
  addOnPrograms: { [key: string]: IVendorDTO[] }
  searchText: string
}

const filterPlans = (plans: IVendorDTO[] | undefined, searchText: string) =>
  plans?.filter(
    (p) =>
      searchText === '' ||
      p.programName.toLowerCase().includes(searchText.toLowerCase())
  ) ?? []

const AddOnProgramsSectionsContainer = ({
  addOnPrograms,
  searchText
}: AddOnProgramsSectionsContainerProps) => {
  const filteredPrograms = Object.entries(addOnPrograms)
    .map(([key, value]) => {
      return {
        name: key,
        plans: filterPlans(value, searchText)
      }
    })
    .filter((program) => !!program.plans?.length)

  if (filteredPrograms.length) {
    return (
      <>
        {filteredPrograms.map((program) => {
          return (
            <AddOnProgramSection
              filteredPlans={program.plans}
              programName={program.name}
            />
          )
        })}
      </>
    )
  }

  return <div className="text-secondary">No programs found</div>
}

export default AddOnProgramsSectionsContainer
